module.exports = "<p-dialog [(visible)]=\"modalConfirm\" modal=\"modal\" [header]=\"header\" (onHide)=\"cancelClick();\">\n    <div class=\"container-fluid row\">\n        <p style=\"white-space: pre;\">{{message}}</p>\n    </div>\n    <p-footer>\n        <button #cancelButton class=\"btn btn-default\" type=\"button\" (click)=\"cancelClick()\">Cancel</button>\n        <button class=\"btn btn-default\" type=\"button\" (click)=\"okClick()\">OK</button>\n    </p-footer>\n</p-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal-confirm/modal-confirm.component.html
// module id = ./src/app/components/modal-confirm/modal-confirm.component.html
// module chunks = main